import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const HELPING_GET_DETAIL_OK = "HELPING_GET_DETAIL_OK";
export const HELPING_GET_DETAIL_ERR = "HELPING_GET_DETAIL_ERR";

export function helpingGetDetailOk(payload) {
  return {
    type: HELPING_GET_DETAIL_OK,
    payload,
  };
}

export function helpingGetDetailErr(payload) {
  return {
    type: HELPING_GET_DETAIL_ERR,
    payload,
  };
}

export const helpingGetDetailService = {
  getDetail,
};

function getDetail(id) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.HelpingGetDetail + id)
      .then((response) => {
        dispatch(helpingGetDetailOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(helpingGetDetailErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
